var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from "~/core/decorator";
var CaseOutContrastController = /** @class */ (function () {
    function CaseOutContrastController() {
    }
    /**
     * 下载对账单模板
     */
    CaseOutContrastController.prototype.downLoadBill = function () {
        return this.netService.send({
            server: domainService.caseOutContrastController.downLoadBill,
        });
    };
    /**
     * 下载还款记录模板
     */
    CaseOutContrastController.prototype.downLoadRepaymentRecord = function () {
        return this.netService.send({
            server: domainService.caseOutContrastController.downLoadRepaymentRecord,
        });
    };
    __decorate([
        Inject(NetService)
    ], CaseOutContrastController.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], CaseOutContrastController.prototype, "downLoadBill", null);
    __decorate([
        Debounce()
    ], CaseOutContrastController.prototype, "downLoadRepaymentRecord", null);
    return CaseOutContrastController;
}());
export { CaseOutContrastController };
